import React from "react";
import compose from "recompose/compose";
import Card from "@material-ui/core/Card";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { translate } from "react-admin";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";

import CardIcon from "./CardIcon";

const styles = {
  main: {
    marginBottom: 20
  },
  card: {
    overflow: "inherit",
    textAlign: "right",
    padding: 16,
    minHeight: 52
  },
  anterior: {
    margin: "0 16px 10px 16px",
    fontSize: "14px"
  },
  subTitle: {
    fontSize: 16,
    padding: "10px 20px"
  }
};

const Asistencias = ({
  titulo,
  subtitulo,
  actual,
  anterior,
  list,
  classes,
  icon
}) => (
  <Card className={classes.main}>
    <div className={classes.card}>
      <CardIcon Icon={icon} />
      <Typography color="textSecondary">{titulo}</Typography>
      <Typography variant="headline" component="h2">
        {actual} kgs.
      </Typography>
    </div>
    <Typography
      variant="subtitle1"
      color="textSecondary"
      className={classes.anterior}
    >
      Total del mes anterior: <strong>{anterior}</strong>
    </Typography>
    {list && (
      <div>
        <Divider />
        <List component="nav" style={{ overflow: "auto", maxHeight: 300 }}>
          {subtitulo && (
            <Typography className={classes.subTitle} color="textSecondary">
              {subtitulo}
            </Typography>
          )}
          {list}
        </List>
      </div>
    )}
  </Card>
);

const enhance = compose(withStyles(styles), translate);

export default enhance(Asistencias);



// WEBPACK FOOTER //
// ./src/components/dashboard/cards/kpi.js